var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "el-drag-dialog",
          rawName: "v-el-drag-dialog",
          value: _vm.drag,
          expression: "drag",
        },
      ],
      ref: "mydialog",
      attrs: {
        width: _vm.width,
        title: _vm.title,
        visible: _vm.newValue,
        "append-to-body": _vm.appendToBody,
        "custom-class": _vm.customClass,
        "show-close": false,
        "close-on-click-modal": false,
        "press-escape": false,
        modal: _vm.modal,
        "close-on-press-escape": _vm.closeOnPressEscape,
        top: _vm.top,
      },
      on: {
        "update:visible": function ($event) {
          _vm.newValue = $event
        },
        open: _vm.open,
        close: function ($event) {
          return _vm.$emit("beforeClose")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ss-material-box-header",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c(
            "div",
            { staticClass: "ss-material-box-header-title" },
            [_vm._v(" " + _vm._s(_vm.title) + " "), _vm._t("title")],
            2
          ),
          _vm.showClose
            ? _c("i", {
                staticClass: "el-icon-close close",
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              })
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-body-content",
          style: { width: _vm.width, height: _vm.height },
        },
        [_vm._t("default")],
        2
      ),
      _vm._t("footer", function () {
        return [
          _c(
            "div",
            { staticClass: "ss-material-box-bottom" },
            [
              _vm.btnFooter
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.succese()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.footerText[0]))]
                  )
                : _vm._e(),
              _vm.btnFooter
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.footerText[1]))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }